import React from "react";
import styles from "./EpisodeCard.module.css"
import {LinearProgress, Stack, Typography} from "@mui/material";
import {ISeasonsChapters} from "../types";
import clsx from "clsx";
import {CardSerials} from "../../index";

interface IProps {
    data: ISeasonsChapters,
    seasonNumber?: number | string,
    activeNumber?: number | string,
    classCard?: string;
    onEpisodeChange: (seasonNumber: number, episodeNumber: number) => void; // Add this prop for episode change
    isMobileControls?: boolean
}

const EpisodeCard: React.FC<IProps> = ({data,classCard, onEpisodeChange, isMobileControls, seasonNumber, activeNumber}) => {

    const handleEpisodeClick = () => {
        onEpisodeChange(seasonNumber as number, data?.chapter_number); // Trigger the callback with season and episode numbers
    };
    const checkActiveEpisode = data?.chapter_number === activeNumber
    return (
        <div className={styles.wrapper}>
            {!isMobileControls ?
                <div className={clsx(styles.card, classCard)} onClick={handleEpisodeClick}>
                <div>
                    <img src={data?.poster} alt={"MovieItem"} loading={"lazy"}
                         className={clsx(styles.poster, checkActiveEpisode && styles.poster_active)}/>
                </div>


                <div className={styles.progress_wrapper}>
                    <Typography variant={"h2"}
                                className={styles.episode_count}>Episode {data?.chapter_number}</Typography>
                    <Typography variant={"h2"} className={styles.episode_title}>{data?.title}</Typography>
                    <Typography variant={"h4"}>{data?.duration}</Typography>
                </div>
            </div> :

                <Stack direction={"row"} alignItems={"center"} gap={4} onClick={handleEpisodeClick} className={styles.root}>
                    <div className={styles.card}>
                        <img
                            src={data?.poster}
                            alt={"MovieItem"}
                            loading={"lazy"}
                            className={clsx(styles.poster, checkActiveEpisode && styles.poster_active)}
                        />
                        {data?.chapter_number === 0 && (
                            <div className={styles.progress_wrapper}>
                                <LinearProgress variant="determinate" value={25} className={styles.progress}/>
                            </div>
                        )}
                    </div>
                    <Stack gap={"40px"} className={styles.root_right}>
                        <Stack gap={2}>
                            <Typography variant={"h5"}>Episode {Number(data?.chapter_number)}</Typography>
                            <Typography variant={"h2"}>{data?.title}</Typography>
                        </Stack>
                        <Typography variant={"h5"}>{data?.duration}</Typography>
                    </Stack>
                </Stack> }

        </div>
    );
};

export default EpisodeCard;
